












































import RecordedItemMenu from '@/components/recorded/RecordedItemMenu.vue';
import { RecordedDisplayData } from '@/model/state/recorded/IRecordedUtil';
import { Component, Prop, Vue } from 'vue-property-decorator';
import * as apid from '../../../../api';

@Component({
    components: {
        RecordedItemMenu,
    },
})
export default class RecordedSmallCard extends Vue {
    @Prop({ required: true })
    public item!: RecordedDisplayData;

    @Prop({ required: false })
    public noThumbnail: boolean | undefined;

    @Prop({ required: true })
    public isEditMode!: boolean;

    @Prop({ required: true })
    public isShowDropInfo!: boolean;

    public gotoDetail(): void {
        if (this.isEditMode === true) {
            this.$emit('selected', this.item.recordedItem.id);

            return;
        }
        this.$emit('detail', this.item.recordedItem.id);
    }

    public stopEncode(recordedId: apid.RecordedId): void {
        this.$emit('stopEncode', recordedId);
    }

    public openRule(): void {
        const ruleId = this.item.display.ruleId;
        if (typeof ruleId === 'undefined') {
            return;
        }
        this.$router.push({ path: '/recorded', query: { ruleId: ruleId.toString(10) } });
    }
}
